import {TextAreaRef} from 'antd/lib/input/TextArea';
import {isNull} from 'lodash';
import {ReactNode, RefObject, useState} from 'react';

import {useUser} from '../../../../../../../provider/user/user-hook';
import {ResponseTemplateDataType} from '../../../../../../../service/reviews/reviews-response-templates';
import {ReviewDataType} from '../../../../../../../service/reviews/reviews-type';
import {IdNumberType} from '../../../../../../../util/type';
import {AutoReplyTemplatePopup} from '../../../../../auto-reply-form/auto-reply-form-popup/auto-reply-template-popup';
import {useReviewAnswer} from '../../../../reviews-state/reviews-answer-hook';
import {useReviewStateHook} from '../../../../reviews-state/reviews-state-provider';

import {NewAiReviewGeneratorButton} from './ai-review-generator/new-ai-review-generator-button';
import {ReplyTypeEnum} from './reply-form-const';

type PropsType = {
    reviewData: ReviewDataType;
    replyAreaRef: RefObject<TextAreaRef>;
    rows?: number;
    onFocus?: () => void;
    isFocus?: boolean;
    isOpen: boolean;
    isGptSuggestSupported?: boolean;
    extraActions?: ReactNode;
};

export function NewReplyForm(props: PropsType): JSX.Element | null {
    const {reviewData, replyAreaRef, isGptSuggestSupported, isOpen, extraActions} = props;
    const {brand, id: reviewId, ableToReply, children, comment, catalogId} = reviewData;

    const [isSelectTemplatePopupOpen, setIsSelectTemplatePopupOpen] = useState<boolean>(false);
    const [selectedTemplateList, setSelectedTemplateList] = useState<Array<IdNumberType>>([]);
    const [selectedResponseTemplateList, setSelectedResponseTemplateList] = useState<Array<ResponseTemplateDataType>>(
        []
    );
    const {setReviewAnswer} = useReviewStateHook();
    const [answerText, setAnswerText] = useReviewAnswer(reviewId);

    const [answerType, setAnswerType] = useState<string>(ReplyTypeEnum.ManualReply);

    const {user} = useUser();

    function isShowGenerateButton() {
        if (isNull(comment) || comment?.length < 1 || !isGptSuggestSupported) {
            return false;
        }

        if (user?.isTestUser || user?.isDemoCpUser) {
            return !children || children?.length === 0;
        }

        return ableToReply && (!children || children?.length === 0);
    }

    return (
        <>
            {isOpen && (
                <NewAiReviewGeneratorButton
                    answerText={answerText}
                    answerType={answerType}
                    brand={brand}
                    comment={comment}
                    extraActions={extraActions}
                    isShowGenerateButton={isShowGenerateButton()}
                    replyAreaRef={replyAreaRef}
                    reviewId={reviewId}
                    setAnswerText={setAnswerText}
                    setAnswerType={setAnswerType}
                    setIsSelectTemplatePopupOpen={setIsSelectTemplatePopupOpen}
                />
            )}
            {isSelectTemplatePopupOpen && (
                <AutoReplyTemplatePopup
                    catalogIds={[catalogId]}
                    isOpen
                    isRadioMode
                    onCancel={() => setIsSelectTemplatePopupOpen(false)}
                    onOk={() => {
                        setIsSelectTemplatePopupOpen(false);

                        const [selectedAutoReply] = selectedResponseTemplateList;

                        if (!selectedAutoReply) {
                            return;
                        }

                        const {message} = selectedAutoReply;

                        setReviewAnswer(reviewId, message);
                        setAnswerType(ReplyTypeEnum.TemplateReply);
                    }}
                    reviewId={reviewId}
                    selectedItemList={selectedTemplateList}
                    selectedResponseTemplateList={selectedResponseTemplateList}
                    setSelectedItemList={setSelectedTemplateList}
                    setSelectedResponseTemplateList={setSelectedResponseTemplateList}
                    shouldRememberGroupFilter
                />
            )}
        </>
    );
}
